import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { i as input, l as label, b as inputInvalid, c as inputDisabled, d as inputFocused } from './parts.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';
import { d as defineCustomElement$2 } from './custom-popper2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const SelectInput = /*@__PURE__*/ proxyCustomElement(class SelectInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.isFocused = false;
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit(target.value);
        };
        this.updateInput = (newValue) => {
            this.selectElement.value = newValue;
        };
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    get part() {
        let part = input;
        if (this.errorText) {
            part = inputInvalid;
        }
        if (this.disabled) {
            part = inputDisabled;
        }
        if (this.isFocused) {
            part = inputFocused;
        }
        return part;
    }
    render() {
        var _a;
        return (h(Host, { key: '35a1bdaf0e3afc2abc6b9c017534ff195b2fb22b' }, h("div", { key: '1a8bfb04cf91d414baf545feb200d9b77ffbfd44', class: "form-group d-flex flex-column" }, h("div", { key: 'ed7855bf66a29de36e0ef89be041dcc808bc4b17', class: "d-flex align-items-start gap-2" }, h("label", { key: '5d7a7191e4b021b6c37b16565b1e6f18f70b39d2', part: label, class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: 'c449d19d68a4751bab7def93e8bace73702955c6', helpText: this.helpText })), h("select", { key: '3c3b1066af005d6705ec9bd2bbed48956dba0222', ref: el => (this.selectElement = el), id: this.name, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onInput: this.handleFormControlInput, part: this.part, class: this.errorText ? 'form-select is-invalid' : 'form-select', disabled: this.disabled }, (_a = this.options) === null || _a === void 0 ? void 0 : _a.map(option => (h("option", { value: option.value }, option.label)))), h(FormControlErrorText, { key: '366ae472571ad3be5ca1f38a688aaf22c7afb74d', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-select", {
        "name": [8],
        "label": [1],
        "options": [16],
        "inputHandler": [16, "input-handler"],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "disabled": [4],
        "isFocused": [32]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-select", "custom-popper", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SelectInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { SelectInput as S, defineCustomElement as d };
